import React from 'react';
import {
  CouponScopeColors,
  CouponScopeLabels,
} from '../../../../api/payments/coupons/domain/labels';
import { JdsTag } from '../../../../components/jds/JdsTag';

export function CouponScopeTag({ scope }) {
  return (
    <JdsTag
      color={CouponScopeColors[scope] ?? 'neutral'}
      label={CouponScopeLabels[scope] ?? scope}
    />
  );
}

const ACCENT_TOKENS = {
  success: '--fg-success-strong',
  info: '--fg-info-strong',
  warning: '--fg-warning-stronger',
};

// Cor de destaque (ex.: borda do card) do mesmo tom da tag do escopo.
export const getScopeAccent = (scope) =>
  `var(${ACCENT_TOKENS[CouponScopeColors[scope]] ?? '--border-neutral-default'})`;
